import { NOMES_HABILIDADE, forcaPorHabilidade, habilidadesDe, type ChaveHabilidade, type Jogador } from '../core';

const ORDEM: ChaveHabilidade[] = ['gol', 'des', 'arm', 'fin', 'vel', 'tec', 'pas'];

/** Barras das habilidades do jogador (Goleiro, Desarme, Armação, Finalização, Velocidade, Técnica e Passe). */
export function blocoHabilidades(j: Jogador): string {
  const h = habilidadesDe(j);
  const linhas = ORDEM.map((k) => {
    const v = h[k];
    const cor = v >= 60 ? '#2fd06a' : v >= 40 ? '#ffd24a' : '#d9412c';
    return `<div class="hab-linha"><span>${NOMES_HABILIDADE[k]}</span><div class="hab-barra"><i style="width:${v}%;background:${cor}"></i></div><b>${v}</b></div>`;
  }).join('');
  return `<div class="habilidades" title="Habilidades próprias do jogo (base criada aqui, não existe fonte real)"><div class="hab-tit">Habilidades · força na posição ${Math.round(forcaPorHabilidade(j))}</div>${linhas}</div>`;
}
